import { render } from "./DiagnosisScreenList.vue?vue&type=template&id=4d23968e&scoped=true"
import script from "./DiagnosisScreenList.vue?vue&type=script&lang=js"
export * from "./DiagnosisScreenList.vue?vue&type=script&lang=js"

import "./DiagnosisScreenList.vue?vue&type=style&index=0&id=4d23968e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d23968e"]])

export default __exports__